import { render } from "./LoadingSpinnerIcon.vue?vue&type=template&id=31645b52"
const script = {}
script.render = render

export default script